import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Box, Loading } from "orcs-design-system";
import { Scale } from "@unovis/ts";
import {
  VisXYContainer,
  VisAxis,
  VisLine,
  VisBulletLegend,
} from "@unovis/react";

const CapacityDemandChart = ({ types, dataTypes, data, loading }) => {
  const xLine = useCallback((d) => +new Date(d.date), []);
  const yLine = [
    useCallback((d) => d.capacityFte, []),
    useCallback((d) => d.allocatedFte, []),
  ];
  const color = useCallback(
    (d, i) => {
      return i === 0
        ? dataTypes[types.supply].color
        : dataTypes[types.demand].color;
    },
    [dataTypes, types]
  );

  const xTicks = useCallback((xLabel) => {
    return moment(xLabel).format("MMM YYYY");
  }, []);

  const yTicks = Intl.NumberFormat(navigator.language, {
    notation: "compact",
  }).format;

  const xScale = useMemo(() => Scale.scaleTime(), []);

  if (loading) {
    return (
      <Box height="50vh">
        <Loading height="100%" large centered />
      </Box>
    );
  }

  return (
    <VisXYContainer data={data} height="50vh" xScale={xScale}>
      <VisBulletLegend items={Object.values(dataTypes)} />
      <VisLine x={xLine} y={yLine} color={color} />
      <VisAxis type="x" numTicks={6} tickFormat={xTicks} />
      <VisAxis type="y" tickFormat={yTicks} />
    </VisXYContainer>
  );
};

CapacityDemandChart.propTypes = {
  types: PropTypes.object.isRequired,
  dataTypes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default CapacityDemandChart;
